import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ExpedienteService } from 'src/app/services/expediente.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'gineco',
  templateUrl: './gineco.component.html',
})

export class GinecoComponent {

  formGineco: FormGroup;

  @Input() public id_paciente = null;

  public datos_gineco = {
    "id_paciente" : "",
    "menstruacion" : "",
    "regular" : "",
    "sexual" : "",
    "anticonceptivo" : "",
    "embarazo" : "",
    "hijos" : "",
    "lactando" : "",
    "complicaciones" : "",
    "abortos" : ""
  };

  constructor(
    private spinner: NgxSpinnerService,
    private _bilder: FormBuilder,
    private _expedienteService: ExpedienteService,
  ){

  }

  ngOnInit(){
    this.colocarValores();
    this.obtenerGineco();
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  colocarValores( gineco = null ){
    let datos = null;
    if( gineco != null ){
      datos = gineco;
    }else{
      datos = this.datos_gineco;
      datos.id_paciente = this.id_paciente;
    }

    this.formGineco = this._bilder.group({
      id_paciente : [datos.id_paciente],
      menstruacion : [ datos.menstruacion ],
      regular : [ datos.regular ],
      sexual : [ datos.sexual ],
      anticonceptivo : [ datos.anticonceptivo ],
      embarazo : [ datos.embarazo ],
      hijos : [ datos.hijos ],
      lactando : [ datos.lactando ],
      complicaciones : [ datos.complicaciones ],
      abortos : [ datos.abortos ]
    });
  }

  obtenerGineco(){
    this.spinner.show('spnr-s');
    if( this.id_paciente != null){
      let respuesta = this._expedienteService.obtenerGineco( this.id_paciente );
      respuesta.then(
        val =>{
          if( val.status == "success" ){
            this.spinner.hide('spnr-s');
            if( val.obstetricos != null ){
              this.colocarValores( val.obstetricos );
            }
          }else{
            this.spinner.hide('spnr-s');
            Swal.fire({
              title: 'Oopss...',
              text: val.message,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#1beb11',
            });
          }
        },
        error =>{
          this.spinner.hide('spnr-s');
          Swal.fire({
            title: 'Oopss...',
            text: 'Ha ocurrido un problema al cargar los datos, se recomienda recargar la pagina.',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });
        }
      );
    }else{
      this.spinner.hide('spnr-s');
      Swal.fire({
        title: 'Oopss...',
        text: 'Ha ocurrido un problema al cargar los datos, se recomienda recargar la pagina.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#1beb11',
      });
    }
  }

  registrarGineco( datos ){
    this.spinner.show('spnr-s');
    let respuesta = this._expedienteService.registrarGineco( datos );
    respuesta.then(
      val =>{
        if( val.status == "success" ){
          this.spinner.hide('spnr-s');
          Swal.fire({
            title: "Registro Exitoso",
            icon: 'success',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });
        }else{
          this.spinner.hide('spnr-s');
          Swal.fire({
            title: 'Oopss...',
            text: val.message,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#1beb11',
          });

        }
      },
      error =>{
        this.spinner.hide('spnr-s');
        Swal.fire({
          title: 'Oopss...',
          text: "Ha ocurrido un problema al registrar los datos, por favor intentalo nuevamente.",
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#1beb11',
        });
      }
    );

  }

}
